import React, {useState,useRef, useEffect } from 'react';
import CustomButtoncolor from "../custom-button/customColorButton";
import {Avatar, Box, Button, Checkbox, FormControlLabel, Grid, Hidden, Stack, Tab, Tabs, Typography} from "@mui/material";
import CustomModal from "../modal/customModal";
import moment from "moment/moment";
import {
    getCrmAppointmentHolidays,
    getCrmAppointmentSchedule,
    rescheduleAppointment
} from "../../store/crm/appointment/book-appointment";
import {useDispatch, useSelector} from "react-redux";
import Loader from "../loader/loader";
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import AppointmentTime from "../../pages/crm/appointment/add-appointment/appointmentTime";
import {MySwal, successConfirmation} from "../../services/utills";
import {mySwalButton, mySwalButtonCancel, mySwalButtonYes} from "./CardAppointment";
import CustomButton from "../custom-button/customButton";
import {getAllAppointment, getAppointmentDetails, getAppointmentHistory, getAppointmentcalender} from "../../store/crm/appointment";
import Waveloading from '../../pages/loading/Waveloading';
import { Navigate, useNavigate } from 'react-router';
import { getCRMCustomerBookingsDetails } from '../../store/crm/crm';
import { appointmentCallLogData } from '../../store/crm/call-log';
import CRMPage from '../../pages/crm/crmpage/CRMPage';
import { getStaff } from '../../store/crm/staffs';
import { getProviderStaff } from '../../store/crm/staff';
import EventRepeatIcon from '@mui/icons-material/EventRepeat';
import Customcolorbtn from '../custom-button/customeColorCalender';
import toast from 'react-hot-toast';

const AppointmentCalender = ({ isbtn, triggerReload,appointment,isConfirm, iscall, isBooking, isAppointment,isRequested,isMouseEnter,setIsMouseEnter,fetchAppointment, fwidth,onRescheduleSuccess,startDate,endTime, isCalender}) => {
    const [rescheduleModal, setRescheduleModal] = useState(false)
    const [loading, setLoading] = useState(false)
    const [selectedFinalDate,setSelectedFinalDate] = useState(null)
    const [selectedTime,setSelectedTime] = useState(null) 
    const navigate = useNavigate()
      const [selectedStaff, setSelectedStaff] = useState(null)

    const [apiValue, setApiValue] = useState(1);  
    const crmStaffStore = useSelector(state => state?.crmStaffStore)
    const {crmStaffs = []} = crmStaffStore
    const handleCheckboxChange = (event) => {
        const checked = event.target.checked;
        setApiValue(checked ? 1 : 0);
      };

 

      //console.log("resecdule data coming",appointment)
 
    const dispatch = useDispatch()  

    useEffect(() => {
        if (appointment?.staff?.id && crmStaffs?.length > 0) {
          const matched = crmStaffs.find((staff) => staff.id === appointment.staff.id);
          if (matched) {
            setSelectedStaff(matched);
          }
        }
      }, [appointment, crmStaffs]);
      
      const handleStaffSelection = (staff) => {
        if (selectedStaff?.id === staff.id) {
          setSelectedStaff(null);
          //console.log("staff",selectedStaff?.id)
        } else {
          setSelectedStaff(staff);
          //console.log("staff",selectedStaff?.id)
        //   scrollRef.current?.scrollIntoView({ behavior: "smooth" });
        }
      };
    const getAppointmentHoliday = async (date, staff) => {
        setLoading(true) 
        let finalDate = moment(date).format('YYYY-MM-DD')
        // setSelectedFinalDate(finalDate)
        if (finalDate) {
            let finalData = {
                date: finalDate
            }
          /*  if (staff?.id) {
                finalData['staff_id'] = staff?.id
            }*/
            await dispatch(getCrmAppointmentHolidays(finalData))
        }

        setLoading(false)      

    }
    const getAppointmentSchedule = async (date) => {

        setLoading(true)
        let serviceIds = []
        appointment?.services.forEach((item) => {
            serviceIds.push(item?.id)
        })


        let finalDate = moment(date).format('YYYY-MM-DD')

        setSelectedFinalDate(finalDate)
        setSelectedTime(null)
        let finalData = {
            date: finalDate,
            service_ids: serviceIds
        }

        await dispatch(getCrmAppointmentSchedule(finalData))
  
        setLoading(false)           
       
    }    
 
    const handleReschedule = async () => {
        let confirm = await MySwal.fire({ 
            // icon: 'question',   
            title: 'Reschedule?',
           
            showConfirmButton: false,
            customClass: {
                icon: 'custom-icon-size',
                popup: 'custom-popup-shadow',
                closeButton: 'custom-close-button',
              },
            showCloseButton: true,
            html:    <Stack
                  sx={{ width: '100%', justifyContent: "center", alignItems: "center" }}
                  direction={{ xs: 'column', lg: 'row',sm:"row" }}
                  spacing={2}
                >
                  <Button sx={mySwalButtonYes} onClick={() => MySwal.clickConfirm()}>Yes</Button>
                  <Button sx={mySwalButtonCancel} onClick={() => MySwal.close()}>No</Button>
                </Stack> 
        })
        if (!!confirm?.isConfirmed) {
            if (appointment?.date && appointment?.end_time && appointment?.start_time) {
                let givenDate = moment(appointment?.date);
                let today = moment(new Date());

                    setLoading(true)
                   
                    await getAppointmentHoliday(appointment?.date, appointment?.staff)
                    await getAppointmentSchedule(appointment?.date)
                    dispatch(getProviderStaff())
                    setSelectedFinalDate(appointment?.date)
                      
                    setLoading(false)
                    setRescheduleModal(true)
             
            }else {
                setRescheduleModal(true)
            }
        }
    }
    const handelRescheduleClick = async () => {
        setRescheduleModal(false)
        setLoading(true)
        let finalData = {
            staff_id: selectedStaff?.id || null,
            booking_id:appointment?.id,
            date:selectedFinalDate,
            start_time:selectedTime?.start_time,
            end_time:selectedTime?.end_time,
            is_email_send:apiValue,
        }
        let {payload} = await dispatch(rescheduleAppointment(finalData))

        if (payload?.success === "true"){
          if (isCalender){
            await dispatch(getAppointmentcalender(appointment?.id))
          }
          if(isAppointment){
            await dispatch(getAppointmentDetails(appointment?.id))
            await dispatch(getAllAppointment({start_date:"null",end_date:"null"}))

          }
           //call when reschudle from booking history
          if(isBooking){
            await dispatch (getAppointmentHistory({
              user_id:appointment?.customer?.id,type:'Appointments'
          }))
          await dispatch (getCRMCustomerBookingsDetails({
              id:appointment?.customer?.id,
              type:'Appointments'
          }))
          }
          if(iscall){
            await dispatch(appointmentCallLogData());
          }
            // await dispatch(getAppointmentDetails(appointment?.id))
            // await dispatch (getAppointmentHistory({
            //     user_id:appointment?.customer?.id,type:'Appointments'
            // }))
            // await dispatch (getCRMCustomerBookingsDetails({
            //     id:appointment?.customer?.id,
            //     type:'Appointments'
            // }))

            // await dispatch(getAllAppointment({start_date:"null",end_date:"null"}))
            // await dispatch(appointmentCallLogData());

           
         
            setLoading(false)  

           toast.success("Appointment Rescheduled")
             if(triggerReload){
                triggerReload()
             }

            setRescheduleModal(false)
            if (onRescheduleSuccess) {
                onRescheduleSuccess();
              }
        }else {
            setLoading(false)
        }
    }
    const handleTimeSelect = (slotsArray, startTime) => {
        // Implement your logic for handling time slot selection here
        
        // Scroll to the Reschedule Appointment button
        // if (rescheduleButtonRef.current) {
        //   rescheduleButtonRef.current.scrollIntoView({ behavior: 'smooth' });
        // }
      };
       
      const rescheduleButtonRef = useRef(null);

      // Function to execute scrolling to the reschedule button
      const executeScroll = () => {
        setTimeout(() => {
            rescheduleButtonRef.current.scrollIntoView({ behavior: 'smooth' });
        }, 500);
      };


      
          

    return (
        <Box>
               
            { appointment?.id && <CustomModal
                customWidth={"60%"}
                open={rescheduleModal}
                setOpen={setRescheduleModal}   
            >
                 {/* {loading ? <Waveloading fullSize/>:''} */}
               <Box sx={{display:"flex", flexDirection:{lg:"row",sm:"column",xs:"column"} , justifyContent:'space-between',mb:'10px',mt:'10px' ,gap:"12px"}}>
                   <Typography
                       sx={{textAlign:'center', fontSize: {lg:"20px",sm:"16px",xs:"16px"},mt:"-6px",fontFamily:'helvetica-lt-std-bold'}}
                   >
                       Reschedule Appointment
                   </Typography>
                   { appointment?.date && 
                       <Typography
                           sx={{
                               textAlign: 'center',
                               fontSize: {lg:"20px",sm:"16px",xs:"16px"}, 
                               mt: "-6px",
                               fontFamily: 'helvetica-lt-std-bold',
                           }}  
                       >
                       Current Booking : {moment(appointment?.date).format('dddd, Do MMMM, YYYY')},{appointment?.start_time}
                   </Typography>
                   }

               </Box>
               <Box sx={{ width: '100%' }}>
  {crmStaffs?.length > 0 ? (
    <Tabs
      value={selectedStaff?.id || false}
      variant="scrollable"
      scrollButtons  
      allowScrollButtonsMobile
      onChange={(e, newValue) => {
        const selected = crmStaffs.find((staff) => staff.id === newValue);
        handleStaffSelection(selected);
      }}
      sx={{
        borderBottom: 1,
        borderColor: 'divider',
        mb: 3,
      }}
    >
      {crmStaffs.map((staff) => (
        <Tab
          key={staff.id}
          value={staff.id}
          label={
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <Box sx={{ position: 'relative' }}>
                <Avatar
                  src={staff.profile_image}
                  variant="rounded" 
                  sx={{ width: 100, height: 100 }}
                />
                {selectedStaff?.id === staff.id && (
                  <CheckCircleIcon
                    sx={{
                      color: '#128D64',
                      fontSize: '28px',
                      position: 'absolute',
                      top: -10,
                      right: -10,
                      background: '#fff',
                      borderRadius: '50%',
                    }}
                  />
                )}
              </Box>
              <Typography sx={{ mt: 1, fontFamily: selectedStaff === staff?.id ? 'helvetica-lt-std-bold' : 'helvetica-lt-std-roman', }}>{staff.name}</Typography>
            </Box>
          }
          sx={{
            minWidth: 120,
            textTransform: 'none',
            padding: 2,
            display: 'flex',
            justifyContent: 'center',
          }}
        />
      ))}
    </Tabs>
  ) : (
    <Typography>No Staff Found</Typography>
  )}
</Box>
                <AppointmentTime  
                    selectedFinalDate={selectedFinalDate}
                    setSelectedFinalDate={setSelectedFinalDate}
                    selectedTime={selectedTime}   
                    selectedStaff={appointment?.staff || null}    
                    setSelectedTime={setSelectedTime} 
                    selectedServices={appointment?.services}
                    getAppointmentHoliday={getAppointmentHoliday}
                    getAppointmentSchedule={getAppointmentSchedule}
                    handleTimeSelect={handleTimeSelect}
                    executeScroll={executeScroll} 
                  

                />
                  <Box sx={{display:"flex",gap:"3",marginLeft:"19px"}}>
                                              <Box>
                                              <FormControlLabel
                                                            // key={index}
                                                            // value={method?.name}
                                                            size="small"      
                                                            control={
                                                                <Checkbox  
                                                                checked={apiValue === 1}
                                                                onChange={handleCheckboxChange}
                                                                />
                                                            }         
                                                            label={"Send Notification"}  
                                                            sx={{   
                                                               '& .MuiSvgIcon-root': {  
                                                                    fontSize: 20,  
                                                                      },
                                                            }}
                                                        />  
                                            </Box>
                                            </Box>
                {
                    selectedTime?.start_time &&<Box  ref={rescheduleButtonRef} sx={{display:'flex',justifyContent:"center",mt:'24px'}}>
                    <CustomButton    handleClick={handelRescheduleClick} val={'Reschedule Appointment'} />
                </Box>
                }
                
              
            </CustomModal>}
            {loading ? <Waveloading fullSize/>:''}
            {isRequested ?
                <Button
                    variant="outlined"
                    color="info"
                    onMouseEnter={() => {
                        setIsMouseEnter(true)
                    }}
                    onMouseLeave={() => {
                        setIsMouseEnter(false)
                    }}
                    onClick={() => isMouseEnter && appointment?.id  && handleReschedule()}
                    sx={{
                        height:'100%'
                    }}
                >
                    Reschedule
                </Button>
                : isConfirm ?
                <Box sx={{ mt:4, }}>
                    <Typography
                        variant="h6"
                        color="initial"
                        sx={{
                            color:'#1565c0',
                            marginTop:'5px',
                            fontFamily: "helvetica-lt-std-bold",
                            cursor:'pointer',
                        }}
                        onClick={() =>appointment?.id  && handleReschedule()}
                    >
                        Reschedule appointment
                    </Typography>
                </Box>
                :
            <Customcolorbtn
                mainColor={"#ff5907"}
                handleClick={() =>appointment?.id  && handleReschedule()}
                style={{borderRadius: "4px", padding: '10px 15px', width: fwidth}}
                val={"Reschedule"}
                 icon={isbtn ? <EventRepeatIcon /> : null}    
            />
            }

        </Box>
    );
};

export default AppointmentCalender;